import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    console.log(pathnames);

    const breadcrumbItems = [
        { name: "Dashboard", path: "/dashboard" },
        { name: "Network / Downline Member", path: "/downline" },
        { name: "Network / Genealogy Tree", path: "/genealogy" },
        { name: "Finance / E-wallet", path: "/ewallet" },
        { name: "Finance / Payout", path: "/payout" },
        { name: "Network / Downline Member / Add Member", path: "/addmember" },
        { name: "Network / Downline Member / Edit Member", path: "/editmember" },
        { name: "Profile", path: "/profile" },
        { name: "Profile / Edit Profile", path: "/editprofile" },
        { name: "Settings", path: "/settings" },
    ];

    const getBreadcrumbParts = (breadcrumb) => {
        return breadcrumb.name.split(" / ");
    };

    return (
        <div className="container pt-2">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb d-flex">
                    {pathnames.map((pathname, index) => {
                        if (index == 0) {
                            const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                            const breadcrumb = breadcrumbItems.find((b) => to === b.path);
                            const breadcrumbParts = breadcrumb ? getBreadcrumbParts(breadcrumb) : [];

                            // console.log(breadcrumbParts);
                            // console.clear();

                            return (
                                <li
                                    key={to}
                                    className={`breadcrumb-item ${index === pathnames.length - 1 ? "active" : ""}`}
                                    aria-current={index === pathnames.length - 1 ? "page" : undefined}
                                >
                                    {breadcrumbParts.map((part, partIndex) => {
                                        const partPath = breadcrumbParts.slice(0, partIndex + 1).join(" / ");
                                        const partLink = breadcrumbItems.find((b) => b.name === partPath)?.path;

                                        const isEditPage = partLink?.includes("edit");
                                        const isAddPage = partLink?.includes("add");
                                        const isCurrentPage = partLink === location.pathname;

                                        // console.log(part);
                                        // console.log(partPath);
                                        // console.log(partLink);

                                        // console.log(breadcrumbParts.length);
                                        const lastIndex = breadcrumbParts.length - 1;
                                        // console.log(lastIndex);

                                        return (
                                            <>
                                                <span key={partIndex}>
                                                    {index === pathnames.length - 1 && partIndex === breadcrumbParts.length - 1 ? (
                                                        isEditPage || isAddPage ? (
                                                            part
                                                        ) : (
                                                            part
                                                        )
                                                    ) : partLink && !isEditPage && !isAddPage ? (
                                                        <Link to={partLink} className="text-decoration-none">
                                                            {part}
                                                        </Link>
                                                    ) : (
                                                        part
                                                    )}

                                                    {/* {partIndex !== 0 ? "/" : ""} */}

                                                    {/* {partIndex < breadcrumbParts.length - 1 && " / "} */}
                                                </span>
                                                {partIndex !== lastIndex ? "/" : ""}
                                            </>
                                        );
                                    })}
                                </li>
                            );
                        }
                    })}
                </ol>
            </nav>
            <style jsx>
                {`
                    .breadcrumb {
                        display: flex;
                        flex-wrap: nowrap;
                        padding: 0;
                        margin-bottom: 1rem;
                        list-style: none;
                    }

                    .breadcrumb-item {
                        display: flex;
                    }

                    .breadcrumb-item + .breadcrumb-item::before {
                        content: "/";
                        padding: 0 0.5rem;
                        color: #6c757d;
                    }

                    .breadcrumb-item a {
                        color: #007bff;
                        text-decoration: none;
                    }

                    .breadcrumb-item a:hover {
                        text-decoration: underline;
                    }

                    ol li {
                        width: unset !important;
                    }

                    .breadcrumb-item.active {
                        color: #6c757d;
                    }
                `}
            </style>
        </div>
    );
};

export default Breadcrumb;
